import React from "react";

const SixCareersAt = () => {
  return (
    <section className="events-page-landing-section events-page-careers-section-at">
      <div className="events6ix-layout-page-middle">
        <div className="events-page-careers-section-header text-center">
          <div className="events-page-careers-section-header-heading">
            Life at 6ix
          </div>
          <div className="events-page-careers-section-header-text">
            Our Promise to You
          </div>
        </div>
        <div className="events-page-careers-section-at-row">
          <div className="events-page-careers-section-at-row-col">
            <div className="events-page-careers-section-at-row-col-list">
              <div className="events-page-careers-section-at-row-col-list-content">
                <div className="events-page-careers-section-at-row-col-list-heading">
                  Meaningful Impact
                </div>
                <div className="events-page-careers-section-at-row-col-list-text">
                  Be part of building the future of investment by promoting the
                  free flow of opportunities, ideas, and capital across the
                  globe.
                </div>
              </div>
            </div>
            <div className="events-page-careers-section-at-row-col-list">
              <div className="events-page-careers-section-at-row-col-list-content">
                <div className="events-page-careers-section-at-row-col-list-heading">
                  Radical Transparency
                </div>
                <div className="events-page-careers-section-at-row-col-list-text">
                  We commit to organizational transparency about our investment
                  thesis, goals, successes, and failures. We communicate
                  honestly and openly.
                </div>
              </div>
            </div>

            <div className="events-page-careers-section-at-row-col-list">
              <div className="events-page-careers-section-at-row-col-list-content">
                <div className="events-page-careers-section-at-row-col-list-heading">
                  Ownership Mindset
                </div>
                <div className="events-page-careers-section-at-row-col-list-text">
                  Through our Employee Equity Plan, you'll be an owner in this
                  revolution. As we democratize global investing, your success
                  aligns with ours.
                </div>
              </div>
            </div>
          </div>
          <div className="events-page-careers-section-at-row-col">
            <div className="events-page-careers-section-at-row-col-list">
              <div className="events-page-careers-section-at-row-col-list-content">
                <div className="events-page-careers-section-at-row-col-list-heading">
                  Remote-First Freedom
                </div>
                <div className="events-page-careers-section-at-row-col-list-text">
                  Our global mission is reflected in our culture. Work from
                  anywhere while being part of a worldwide movement to break
                  down investment barriers.
                </div>
              </div>
            </div>
            <div className="events-page-careers-section-at-row-col-list">
              <div className="events-page-careers-section-at-row-col-list-content">
                <div className="events-page-careers-section-at-row-col-list-heading">
                  Accelerated Growth
                </div>
                <div className="events-page-careers-section-at-row-col-list-text">
                  Our comprehensive Leadership Development program is designed
                  to unlock your full potential, preparing you to lead in a
                  rapidly evolving financial landscape.
                </div>
              </div>
            </div>
            <div className="events-page-careers-section-at-row-col-list">
              <div className="events-page-careers-section-at-row-col-list-content">
                <div className="events-page-careers-section-at-row-col-list-heading">
                  Collaborative Innovation
                </div>
                <div className="events-page-careers-section-at-row-col-list-text">
                  Work across teams in our fast-paced environment, gaining
                  exposure to all aspects of our platform while collaborating
                  with diverse, talented colleagues.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SixCareersAt;
